import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import './alltreatment.css';
import { Link } from 'react-router-dom';
import hair from './../../../assets/images/treatments/hair.png'
import skin from './../../../assets/images/treatments/skincare.png'
import dental from './../../../assets/images/treatments/tooth.png'
import homeopathy from './../../../assets/images/treatments/herbal-treatment.png'
import hairtreatment from './../../../assets/images/treatments/hair treatment.webp'
import aidoctor from './../../../assets/images/Doctorsimages/aidoctorfortratementpage.jpg'
import favicon from "../../../assets/images/favicon.ico";


const AllTreatments = () => {
    useEffect(() => {
           document.title = "All Treatments | Advanced Hair, Skin, Dental & Homeopathy – H-Cura";
           const metaDescription = document.querySelector("meta[name='description']");
           if (metaDescription) {
             metaDescription.setAttribute(
               "content",
               "Explore all treatments at H-Cura: Advanced Hair & Skin care, Dental solutions, and holistic Homeopathy. Book expert care in Bangalore & Chennai."
             );
           }
           const metaKeywords = document.querySelector("meta[name='keywords']");
           if (metaKeywords) {
             metaKeywords.setAttribute(
               "content",
               "All treatments at H-Cura: Advanced hair treatments Bangalore/Chennai, Advanced skin treatments Bangalore/Chennai, Dental clinic Jayanagar Bangalore, Homeopathy clinic in Bangalore & Chennai, Hair fall & regrowth treatments, Skin rejuvenation & facials, PRP & GFC hair treatment, HydraFacial & laser skin treatments, Holistic homeopathy solutions, Dental care & smile makeover."
             );
           }
            // Set canonical link
            const existingCanonical = document.querySelector("link[rel='canonical']");
            if (existingCanonical) {
              existingCanonical.setAttribute("href", "https://www.h-cura.com/alltreatments");
            } else {
              const canonicalLink = document.createElement("link");
              canonicalLink.setAttribute("rel", "canonical");
              canonicalLink.setAttribute("href", "https://www.h-cura.com/alltreatments");
              document.head.appendChild(canonicalLink);
            }
            // Set favicon
         const existingFavicon = document.querySelector("link[rel='icon']");
         if (existingFavicon) {
           existingFavicon.setAttribute("href", favicon);
         } else {
           const faviconLink = document.createElement("link");
           faviconLink.setAttribute("rel", "icon");
           faviconLink.setAttribute("type", "image/x-icon");
           faviconLink.setAttribute("href", favicon);
           document.head.appendChild(faviconLink);
         }
         }, []);
    
  return (
    <div className="alltreatmentMedicalSite">
     

      {/* Hero Section */}
      <section className="alltreatmentHeroSection">
        <div className="alltreatmentMainContainer">
          <div className="alltreatmentHeroContent">
            <div className="alltreatmentHeroText">
              <h1>Premium Medical Treatment Solutions</h1>
              <p>Experience world-class healthcare with our specialized treatment services, cutting-edge technology, and expert medical professionals dedicated to your wellness journey.</p>
              <button className="alltreatmentHeroButton" onClick={() => {
                const section = document.getElementById('alltreatment-specialized');
                if (section) {
                  section.scrollIntoView({ behavior: 'smooth' });
                }
              }}>EXPLORE TREATMENTS</button>
            </div>
            <div className="alltreatmentHeroImage">
              <img 
                src={aidoctor} 
                alt="Professional medical team" 
                className="alltreatmentDoctorImage"
              />
              <div className="alltreatmentImageBadge">
                <span className="alltreatmentBadgeIcon">🌿</span>
                <span className="alltreatmentBadgeText">H-CURA</span>
                <span className="alltreatmentBadgeSubtext">Multispecilaity Clinic</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
     <section className="alltreatmentServicesSection">
  <div className="alltreatmentServicesGrid">

    <div className="alltreatmentServiceCard">
      <div className="alltreatmentServiceIcon">
        <img src={hair} width="70" height="70" alt="Hair Treatment Icon" />
      </div>
      <h3>Hair Treatment</h3>
      <p>
        Advanced care for hair fall, dandruff, thinning, and scalp issues. 
        Our treatments focus on natural regrowth and long-term hair health.
      </p>
    </div>

    <div className="alltreatmentServiceCard">
      <div className="alltreatmentServiceIcon">
        <img src={skin} width="70" height="70" alt="Skin Treatment Icon" />
      </div>
      <h3>Skin Treatment</h3>
      <p>
        Personalized skincare solutions for acne, pigmentation, scars, and 
        other skin concerns, helping you achieve healthy, glowing skin.
      </p>
    </div>

    <div className="alltreatmentServiceCard">
      <div className="alltreatmentServiceIcon">
        <img src={dental} width="70" height="70" alt="Dental Care Icon" />
      </div>
      <h3>Dental Care</h3>
      <p>
        Comprehensive dental services including cavity care, cleaning, braces, 
        and cosmetic dentistry for a confident, bright smile.
      </p>
    </div>

    <div className="alltreatmentServiceCard">
      <div className="alltreatmentServiceIcon">
        <img src={homeopathy} width="70" height="70" alt="Homeopathy Icon" />
      </div>
      <h3>Homeopathy</h3>
      <p>
        Safe and natural homeopathy treatments addressing root causes of 
        illnesses with holistic, long-lasting healing.
      </p>
    </div>

  </div>
</section>



      {/* Premium Treatments Section */}
      <section className="alltreatmentListSection" id="alltreatment-specialized">
        <div className="alltreatmentMainContainer">
          <h2 className="alltreatmentSectionTitle">Our Specialized Treatments</h2>
          <p className="alltreatmentSectionSubtitle">
            Discover our premium medical treatments designed with cutting-edge technology and delivered by world-class specialists for exceptional healthcare outcomes.
          </p>
          
          <div className="alltreatmentPremiumGrid">
            <div className="alltreatmentPremiumCard">
              <div className="alltreatmentCardImageWrapper">
                <img 
  src={hairtreatment} 
  alt="Hair Treatment" 
  className="alltreatmentCardImage"
/>

                <div className="alltreatmentCardOverlay">
                  <span className="alltreatmentTreatmentIcon">💇‍♀️</span>
                </div>
              </div>
              <div className="alltreatmentCardContent">
                <h3 className="alltreatmentCardTitle">Hair Treatment</h3>
                <p className="alltreatmentCardDescription">
                  Advanced hair restoration and treatment solutions including PRP therapy, hair transplantation, and scalp treatments for optimal hair health.
                </p>
                <div className="alltreatmentCardFeatures">
                  <span>✓ PRP Therapy</span>
                  <span>✓ Hair Transplant</span>
                  <span>✓ Scalp Care</span>
                </div>
                <Link className="alltreatmentCardButton" to="/advanced-grow-hair-treatment">Learn More</Link>
              </div>
            </div>

            <div className="alltreatmentPremiumCard">
              <div className="alltreatmentCardImageWrapper">
                <img 
                  src="https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                  alt="Skin Treatment" 
                  className="alltreatmentCardImage"
                />
                <div className="alltreatmentCardOverlay">
                  <span className="alltreatmentTreatmentIcon">✨</span>
                </div>
              </div>
              <div className="alltreatmentCardContent">
                <h3 className="alltreatmentCardTitle">Skin Treatment</h3>
                <p className="alltreatmentCardDescription">
                  Comprehensive dermatological care including laser treatments, anti-aging procedures, and medical skincare for radiant, healthy skin.
                </p>
                <div className="alltreatmentCardFeatures">
                  <span>✓ Laser Therapy</span>
                  <span>✓ Anti-Aging</span>
                  <span>✓ Medical Skincare</span>
                </div>
                <Link className="alltreatmentCardButton" to="/advanced-hydrafacial-treatment">Learn More</Link>
              </div>
            </div>

            <div className="alltreatmentPremiumCard">
              <div className="alltreatmentCardImageWrapper">
                <img 
                  src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                  alt="Dental Treatment" 
                  className="alltreatmentCardImage"
                />
                <div className="alltreatmentCardOverlay">
                  <span className="alltreatmentTreatmentIcon">🦷</span>
                </div>
              </div>
              <div className="alltreatmentCardContent">
                <h3 className="alltreatmentCardTitle">Dental Treatment</h3>
                <p className="alltreatmentCardDescription">
                  Complete oral healthcare services including cosmetic dentistry, orthodontics, and advanced dental procedures for perfect smiles.
                </p>
                <div className="alltreatmentCardFeatures">
                  <span>✓ Cosmetic Dentistry</span>
                  <span>✓ Orthodontics</span>
                  <span>✓ Implants</span>
                </div>
                <Link className="alltreatmentCardButton" to="/dental-treatment">Learn More</Link>
              </div>
            </div>

            <div className="alltreatmentPremiumCard">
              <div className="alltreatmentCardImageWrapper">
                <img 
                  src="https://images.unsplash.com/photo-1505751172876-fa1923c5c528?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                  alt="Homeopathy Treatment" 
                  className="alltreatmentCardImage"
                />
                <div className="alltreatmentCardOverlay">
                  <span className="alltreatmentTreatmentIcon">🌿</span>
                </div>
              </div>
              <div className="alltreatmentCardContent">
                <h3 className="alltreatmentCardTitle">Homeopathy</h3>
                <p className="alltreatmentCardDescription">
                  Natural healing approach using homeopathic remedies for holistic wellness, chronic conditions, and preventive healthcare solutions.
                </p>
                <div className="alltreatmentCardFeatures">
                  <span>✓ Natural Remedies</span>
                  <span>✓ Holistic Care</span>
                  <span>✓ Preventive Health</span>
                </div>
                <Link className="alltreatmentCardButton" to="/homeopathy-best-treatments/">Learn More</Link>
              </div>
            </div>
          </div>

          {/* <div className="alltreatmentKnowMoreSection">
            <button className="alltreatmentKnowMoreButton">
              <span>Know More About Our Treatments</span>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div> */}
        </div>
      </section>

      {/* Premium Statistics Section */}
      {/* <section className="alltreatmentStatsSection">
        <div className="alltreatmentMainContainer">
          <div className="alltreatmentStatsGrid">
            <div className="alltreatmentStatItem">
              <div className="alltreatmentStatIcon">🏆</div>
              <h3 className="alltreatmentStatNumber">15+</h3>
              <p className="alltreatmentStatLabel">Years of Excellence</p>
            </div>
            <div className="alltreatmentStatItem">
              <div className="alltreatmentStatIcon">👨‍⚕️</div>
              <h3 className="alltreatmentStatNumber">50+</h3>
              <p className="alltreatmentStatLabel">Expert Specialists</p>
            </div>
            <div className="alltreatmentStatItem">
              <div className="alltreatmentStatIcon">❤️</div>
              <h3 className="alltreatmentStatNumber">25,000+</h3>
              <p className="alltreatmentStatLabel">Happy Patients</p>
            </div>
            <div className="alltreatmentStatItem">
              <div className="alltreatmentStatIcon">⭐</div>
              <h3 className="alltreatmentStatNumber">99%</h3>
              <p className="alltreatmentStatLabel">Success Rate</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Premium Call to Action */}
      <section className="alltreatmentCtaSection">
        <div className="alltreatmentMainContainer">
          <div className="alltreatmentCtaContent" >
            <h2 className="alltreatmentCtaTitle">
              Experience Premium Healthcare Like Never Before
            </h2>
            <p className="alltreatmentCtaSubtitle">
              At H-Cura Multispeciality Clinic, we bring together advanced hair, skin, dental, and homeopathy treatments under one roof, making us your trusted partner for complete health and wellness. Whether you are looking for effective hair fall and regrowth solutions, advanced skin rejuvenation, natural homeopathy care, or professional dental treatments, our team of specialists ensures personalized care for every patient.

            </p>
             <p className="alltreatmentCtaSubtitle">
             Our clinics in Jayanagar (Bangalore) and Madhanandapuram & Valasaravakkam (Chennai) are equipped with modern facilities and expert doctors who combine technology with holistic healing. From PRP & GFC hair therapies, HydraFacial and laser skin treatments, to smile makeover dentistry and natural homeopathy remedies, we provide safe, result-driven solutions tailored to your needs.

            </p>
            <Link className="alltreatmentCtaButton" to="/bookconsultation">
              <span>BOOK YOUR CONSULTATION</span>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 10h12M10 4l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AllTreatments;
